window.io = require('socket.io-client');
window.$ = window.jQuery = require('jquery');
window.moment = require('moment');
require('@fancyapps/fancybox');


import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

//Add Additional plugins for vue
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './sass/app.scss';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth';
import Buefy from 'buefy';
import * as VueGoogleMaps from 'vue2-google-maps';
import InfiniteLoading from 'vue-infinite-loading';
import 'vue-tel-input/dist/vue-tel-input.css';
import VueTelInput from 'vue-tel-input'

Vue.use(VueAxios, axios);
Vue.router = router;
axios.defaults.baseURL = '/api';

Vue.use(VueAuth, {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    rolesVar: 'role',
    loginData: {url: '/login', method: 'POST', redirect: '/home', fetchUser: true},
    logoutData: {url: '/logout', method: 'POST', redirect: '/login', makeRequest: false},
    fetchData: {url: '/auth/user', method: 'GET', enabled: true},
    refreshData: {url: 'auth/refresh', method: 'GET', enabled: false, interval: 30}
});

Vue.use(Buefy, {
    defaultIconPack: 'fas',
    defaultMonthNames: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ],
    defaultDayNames: [
        'Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa',
    ],
    defaultInputAutocomplete: 'off',
    defaultSnackbarDuration: 10000,
    defaultToastDuration: 7000,
});

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBpyMnK6Yc8w6m1KNL7CKg8dvaV0XQG9OQ',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

Vue.use(VueTelInput);

Vue.config.productionTip = false

// Components Partials
Vue.component('b-steps', () => import('./components/bulma/BSteps.vue'));
Vue.component('b-step', () => import('./components/bulma/BStep.vue'));
Vue.component('b-breadcrumb', () => import('./components/bulma/BBreadcrumb.vue'));
Vue.component('b-breadcrumb-item', () => import('./components/bulma/BBreadcrumbItem.vue'));

//Global components
Vue.component('InfiniteLoading', InfiniteLoading);
Vue.component('AuthLayout', () => import('./components/AuthLayout'));
Vue.component('MainNav', () => import('./components/partials/MainNav'));
Vue.component('MainMenu', () => import('./components/partials/MainMenu'));
Vue.component('MainFooter', () => import('./components/partials/MainFooter'));
Vue.component('NotificationNav', () => import('./components/NotificationNav'));
Vue.component('ProfileNav', () => import('./components/ProfileNav'));

//Forms
Vue.component('form-question', () => import('./components/ivr/question/Form'));
Vue.component('form-user', () => import('./components/user/Form'));
Vue.component('FormInput', () => import('./components/form/FormInput'));
Vue.component('FormSelect', () => import('./components/form/FormSelect.vue'));
Vue.component('FormUpload', () => import('./components/form/FormUpload.vue'));
Vue.component('FormSwitch', () => import('./components/form/FormSwitch.vue'));
Vue.component('FormDate', () => import('./components/form/FormDate.vue'));
Vue.component('FormTime', () => import('./components/form/FormTime.vue'));

//data-table
Vue.component('data-table', () => import('./components/DataTable'));
Vue.component('ActionButtons', () => import('./components/ActionButtons'));
//card user
Vue.component('ivr', () => import('./components/ivr/Ivr'));
Vue.component('call-modal', () => import('./components/ivr/CallModal'));
Vue.component('poll-show', () => import('./components/ivr/poll/Show'));
Vue.component('outcoming-modal', () => import('./components/ivr/OutcomingModal'));
Vue.component('incoming-modal', () => import('./components/ivr/IncomingModal'));

Vue.component('card-user', () => import('./components/user/Card.vue'));
Vue.component('show-user', () => import('./components/user/Show.vue'));
Vue.component('view-user', () => import('./components/user/View.vue'));
Vue.component('edit-user', () => import('./components/user/Edit.vue'));

Vue.component('show-call', () => import('./views/ivr/call/ShowCall'));
Vue.component('show-question', () => import('./components/ivr/question/Show'));
Vue.component('twilio-warning', () => import('./components/ivr/TwilioWarning'));


Vue.filter('rol', (type) => {
    let text = '';
    let color = ''
    switch (type) {
        case 'ivr_worker':
        case 'user':
            text = 'Operador';
            color = 'is-info'
            break;
        case 'admin':
            text = 'Administrador';
            color = 'is-success'
            break;
        case 'root':
            text = 'Root';
            color = 'is-danger'
            break;
        default:
            text = '#';
    }
    return text;
    /*   `<span ${color} style="color: black;" class="tag ${color}">
                  ${text}
                </span>`;*/
});

Vue.filter('status', (type) => {
    let text = '';
    let color = ''
    switch (type) {
        case 'completed':
        case 'incomplete_survey':
        case 'interrupt':
            text = 'Completada';
            color = 'is-success'
            break;

        // text = 'Incompleta';
        // color ='is-info'
        // break;
        case 'hangup':
            text = 'Colgada';
            color = 'is-danger';
            break;
            //
            // text = 'Interrumpida';
            // color = 'is-interrupt'
            // break;
        case 'invalid_phone':
            text = 'Número incorrecto';
            color = 'is-interrupt'
            break;
        case 'queued':
            text = 'En espera';
            break;
        case 'in-progress':
            text = 'En llamada';
            break;
        case 'ringing':
            text = 'Timbrando';
            break;
        default:
            text = type;
    }
    return `<span style="color: black;" class="tag ${color}">
              ${text}
            </span>`;
});


Vue.filter('status_color', (type) => {
    let text = '';

    switch (type) {
        case 'completed':
            text = 'Completada';

            break;
        case 'pending':
            text = 'Sin atender';

            break;
        default:
            text = '#';
    }
    return text;
});
Vue.filter('gender', (type) => {
    let text = '';
    switch (type) {
        case 'male':
            text = "Masculino"
            break;
        case 'feme':
            text = "Femenino"
            break;
        default:
            text = '#';
    }
    return text;
})

Vue.filter('date', (date) => {
    if (date == '' || date == null) return "Sin fecha";
    let timedate = ''
    //return timedate = moment(date).format('L')
    return new Date(date).toLocaleDateString();
})
Vue.filter('time', (date) => {
    if (date == '' || date == null) return "Sin fecha"
    let timedate = ''
    return timedate = moment(date).format('LTS')

})
Vue.filter('Duration', (start, end) => {
    if (!start || !end) return "Sin fecha";
    var start = moment(start);
    var end = new moment(end);
    var duration = moment.duration(end.diff(start));
    var hours = duration.asHours();
    var duration = moment.duration(end.diff(start));
    var minutes = duration.asMinutes();
    var duration = moment.duration(end.diff(start));
    var secunds = duration.seconds();

    return parseInt(hours) + ':' + parseInt(minutes) + ':' + parseInt(secunds);
})

Vue.filter('TypeCall', (type) => {
    let result = type;
    switch (type) {
        case 'outcoming':
        case 'outcoming_local':
            result = 'Salida';
            break;
        case 'incoming':
        case 'incoming_local':
            result = 'Entrada';
            break;
    }
    return result;
});
//Prototypes
import backend from './backend';
import loader from './loader';
import notify from './notify';

Vue.prototype.$loader = loader;
Vue.prototype.$backend = backend;
Vue.prototype.$notify = notify;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
